import { baseUrl } from "../../config/env";

export default async function saveVisitor(visitorData) {
    const uri = `${baseUrl.api_Url}/visit/saveVisitor`;

    try {
        const response = await fetch(uri, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(visitorData),
        });

        const resJson = await response.json();
        return [response.status, resJson];
    } catch (error) {
        console.error(`Error in saveVisitor - ${error}`);
        return [500, { error: error.message }];
    }
}
